module.exports = __webpack_public_path__ + "static/itsm_capabilities_3_5-612bca3db5c2f43bcbe88e8d85a9b872.png";